/**
 * convert a number to comma separated
 *
 * \B     start on a non-word boundary
 * (?=)   match only if followed by
 * \d{3}  exactly 3 digits
 * +      one or more of this group
 * (?!)   match only if NOT followed by
 * \d     a digit
 * /g     match globally (as many times as we can find)
 * ","    replace with a comma
 *
 * @param {String} value
 * @returns {String}
 */
export function thousandsSep (value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export function formatNumber (value) {
  if (value == null || value === '') return '0'
  return thousandsSep(Number(value))
}

/**
 * format for percentages
 * @param {Number} value
 * @returns {String}
 */
export function formatPercent (value, precision = 0) {
  return thousandsSep(Number(value).toFixed(precision || 0))
}

/**
 * format for percentages (includes the %)
 * @param {Number} value
 * @returns {String}
 */
export function formatPercentage (value, precision = 0) {
  return `${formatPercent(value, precision)}%`
}

/**
 * format a number as a price
 * convert a number to comma separated, with no decimal places, and prefixed with a $
 * ensures $ is after the - if present.
 * @param {Number} value
 * @param {Integer} [prec] - decimal points
 * @returns {String}
 */
function formatAsPrice (value, prec = 2) {
  if (value == null || value === '') return '$0'
  return thousandsSep(Number(value).toFixed(prec)).replace(/^(-?)/, '$&$$')
}

/**
 * format for price
 */
export function formatPrice (value) {
  return formatAsPrice(value, 2)
}

/**
 * format for price as whole number (no decimals)
 */
export function formatPriceWhole (value) {
  return formatAsPrice(value, 0)
}

/**
 * format for Average price
 */
export function formatAveragePrice (value) {
  return formatAsPrice(value, 2)
}

const monthsShort = [];
for (let i = 0; i < 12; i++) {
  const d = new Date(2000, i, 1)
  monthsShort.push(d.toDateString().split(' ')[1])
}

const dateFmts = {
  'YYYY': d => d.getFullYear(),
  'YY': d => (d.getYear() % 100).toString().padStart(2, '0'),
  'MMM': d => monthsShort[d.getMonth()],
  'MM': d => (d.getMonth() + 1).toString().padStart(2, '0'),
  'DD': d => d.getDate().toString().padStart(2, '0'),
  'hh': d => d.getHours().toString().padStart(2, '0'),
  'mm': d => d.getMinutes().toString().padStart(2, '0')
}

/**
 * @param {String|Date} d
 * @param {String} [format]
 * @returns {String}
 */
export function dateTimeFormat (d, format = '{DD}-{MMM}-{YYYY}') {
  if (typeof d === 'string') { d = new Date(d); }
  if (d === null) return null;
  return format.replace(/{(\w+)}/g, (m, f) => dateFmts[f](d))
}

/*
 * Format a Date to DD-MMM-YYYY
 */
export function formatDate (d) {
  return dateTimeFormat(d, '{DD}-{MMM}-{YYYY}')
}

/*
 * Format a Date to YYYY-MM-DD
 */
export function formatISODate (d) {
  return dateTimeFormat(d, '{YYYY}-{MM}-{DD}')
}

export function parseMonthYear (s) {
  const [m, y] = s.split('-')
  return new Date(Number(y), monthsShort.indexOf(m))
}


/*
 * Checks that string passed is a valid email
 */
export function validateEmail (email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
